import $ from 'n-zepto'
export default{
  install:function (Vue,options) {
    Vue.prototype.checkPhone=function (num) {
      var mobile = /^[1][3-9]\d{9}$/;
      var mobile2 = /^[１][３,４,５,６,７,８][０,１,２,３,４,５,６,７,８,９]{9}$/;
      return mobile.test(num)|| mobile2.test(num);
    }
    Vue.prototype.checkPrice=function (num) {
      var price = /^[1-9][0-9]{0,7}$/;
      return price.test(num);
    }
    Vue.prototype.checkPass=function (num) {
      var password = /^[A-Za-z0-9-_\~!:;|,·`@#\$\^&\*\.\(\)\[\]\{\}<>\\\/\'\"]{6,16}$/;
      return password.test(num);
    }
    Vue.prototype.checkCode=function (num) {
      var code = /^\d{4}$/;
      return code.test(num);
    }
    Vue.prototype.elData=function (json) {
      return eval('(' + json + ')')
    }
    Vue.prototype.getAjax=function (url,data,callback,errFun) {
      $.ajax({
        type: "get",    //请求方式
        url: url,
        dataType: "json",
        crossDomain: true,
        contentType: "application/json;utf-8",
        data: data,
        success: function (data2) {
          //let json=eval('(' + data2 + ')');
          callback(data2);
        },
        error: errFun
      })
    }

    Vue.prototype.getAjaxPack=function (url,data,callback,errFun) {
      $.ajax({
        type: "get",    //请求方式
        url: url,
        dataType: "jsonp",
        crossDomain: true,
        contentType: "application/json;utf-8",
        data: data,
        success: function (data2) {
          //let json=eval('(' + data2 + ')');
          callback(data2);
        },
        error: errFun
      })
    }


    /* 获取cookie*/
    Vue.prototype.setCookie=function (name,value,domain){
      var d = new Date();
      d.setTime(d.getTime() + (24*60*60*1000));
      var expires = "expires="+d.toUTCString();
      if(domain==""){
        document.cookie =  name+ "=" + encodeURI(value) + "; path=/;" + expires;
      }else{
        document.cookie =  name+ "=" + encodeURI(value) + "; domain=.izhaowo.com;path=/;" + expires;
      }

    }
    /*清理cookie*/
    Vue.prototype.clearCookie=function (name,value,domain){
      var d = new Date();
      d.setTime(d.getTime() - 1);
      var expires = "expires="+d.toUTCString();
      if(domain==""){
        document.cookie =  name+ "=" + encodeURI(value) + "; path=/;" + expires;
      }else{
        document.cookie =  name+ "=" + encodeURI(value) + "; domain=.izhaowo.com;path=/;" + expires;
      }
    }
    /*获取cookie*/
    Vue.prototype.getCookie=function (cname){
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return decodeURI(c.substring(name.length, c.length));
      }
      return "";
    }
  }
}



// WEBPACK FOOTER //
// ./src/valid.js